import { render, staticRenderFns } from "./company-title.vue?vue&type=template&id=50bc5cb2"
import script from "./company-title.vue?vue&type=script&lang=js"
export * from "./company-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports